import "./WithdrawalHistory.css";

const WithdrawalHistory = ({ withdrawals, selectedPartner }) => {
  const partnerId = selectedPartner?.id || "all";

  const filtered = withdrawals.filter(w =>
    partnerId === "all" ? true : w.partnerId === partnerId
  );

  // ✅ Calculate total
  const totalWithdrawal = filtered.reduce(
    (sum, w) => sum + Number(w.amount),
    0
  );

  const title =
    partnerId === "all"
      ? "Withdrawal History (All Partners)"
      : `Withdrawal History - ${selectedPartner.name}`;

  return (
    <div className="withdrawal-history">
      <h3>{title}</h3>

      {filtered.length === 0 ? (
        <p className="no-data">
          {partnerId === "all"
            ? "No withdrawals found."
            : `No withdrawals for ${selectedPartner.name}.`}
        </p>
      ) : (
        <>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                {partnerId === "all" && <th>Partner</th>}
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((w, i) => (
                <tr key={i}>
                  <td data-label="Date">
                    {new Date(w.date).toLocaleDateString()}
                  </td>

                  {partnerId === "all" && (
                    <td data-label="Partner">{w.partnerName}</td>
                  )}

                  <td data-label="Amount">{w.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* ✅ TOTAL SECTION */}
          <div className="withdrawal-total">
            <strong>Total Withdrawn: </strong>
            {totalWithdrawal.toFixed(2)}
          </div>
        </>
      )}
    </div>
  );
};

export default WithdrawalHistory;